import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./registration.css"; // Ensure the correct path

const Registration = () => {
  const navigate = useNavigate();
  const [registrationFees, setRegistrationFees] = useState([]);
  const [registrationProcess, setRegistrationProcess] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch registration fees
        const feesResponse = await axios.get(
          `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/registration-info`
        );
        setRegistrationFees(feesResponse.data);

        // Fetch registration process
        const processResponse = await axios.get(
          `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/registration-process`
        );
        setRegistrationProcess(processResponse.data);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Error fetching registration data");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="registration-container">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading registration information...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="registration-container">
        <div className="error-container">
          <p className="error-message">{error}</p>
        </div>
      </div>
    );
  }

  const highlightLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, (url) => {
      const trimmedUrl = url.trim();
      return `<a href="${trimmedUrl}" target="_blank" rel="noopener noreferrer" style="color: #0d6efd;">${trimmedUrl}</a>`;
    });
  };

  const formatProcessText = (text) => {
    // Trim the text first to remove leading/trailing spaces
    text = text.trim();
    
    // First highlight any links
    let formattedText = highlightLinks(text);
    
    // Format account details with proper structure
    formattedText = formattedText
      // Add line breaks before key terms (but not at the very beginning)
      .replace(/\s+(Account Name:|Account Number:|Routing Number:|Bank Name:|Branch Name:|Address:|Mobile Number:)/g, '<br/><strong>$1</strong>')
      // Remove extra spaces
      .replace(/\s+/g, ' ')
      // Add proper spacing after colons
      .replace(/:\s*/g, ': ')
      // Trim any leading line breaks
      .replace(/^<br\/>/, '');
    
    return formattedText;
  };
  

  return (
    <div className="registration-container">
      <div className="process-section">
        <div className="heading-container">
          <h4>Registration Process</h4>
        </div>
        <ul>
          {registrationProcess.length > 0 ? (
            (() => {
              // Create an array with all steps including the hardcoded Step 2
              const allSteps = [
                ...registrationProcess.filter(step => step.step_no !== 2),
                {
                  step_no: 2,
                  process: 'Please fill the registration form ( <a href="https://forms.gle/56uaVCa1wNcF85ja6" target="_blank" rel="noopener noreferrer" style="color: #0d6efd">https://forms.gle/56uaVCa1wNcF85ja6</a> )',
                  isHardcoded: true
                }
              ];
              
              // Sort by step_no
              allSteps.sort((a, b) => a.step_no - b.step_no);
              
              return allSteps.map((step, index) => (
                <li key={index}>
                  <strong>Step {step.step_no}:</strong>{" "}
                  {step.isHardcoded ? (
                    <span dangerouslySetInnerHTML={{ __html: step.process }} />
                  ) : (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: formatProcessText(step.process),
                      }}
                    />
                  )}
                </li>
              ));
            })()
          ) : (
            <li>No registration process data available</li>
          )}
          
          {/* Check Acceptance Status Button as last item */}
          <li className="check-status-item">
            <button 
              className="check-status-btn"
              onClick={() => navigate('/accepted-paper')}
            >
              <svg className="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Check Your Abstract Status
            </button>
          </li>
        </ul>
      </div>

      <div className="fees-section">
        <div className="heading-container">
          <h4>Registration Fees</h4>
        </div>
        <div className="fees-content">
          <table>
            <thead>
              <tr>
                <th>Category</th>
                <th>Local</th>
                <th>International</th>
              </tr>
            </thead>
            <tbody>
              {registrationFees.length > 0 ? (
                registrationFees.map((fee, index) => (
                  <tr key={index}>
                    <td data-label="Category">{fee.category}</td>
                    <td data-label="Local">{fee.local}</td>
                    <td data-label="International">{fee.international}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3">No registration fees data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Registration;
